module.exports = __webpack_public_path__ + "static/media/pucker.4f4086a2.svg";